import { svg } from "lit";
const icon = svg `<path d="M7 40.9999V7H23.9884V9.2692H9.2692V38.7307H23.9884V40.9999H7ZM33.4154 31.6153L31.7654 30.0038L36.6346 25.1346H18.1923V22.8654H36.573L31.7039 17.9962L33.3346 16.3654L40.9999 24.0404L33.4154 31.6153Z" fill="currentColor"/>`;
export default icon;
